// El producto de las primeras piezas, creado a partir de la foto que sube la persona
// (ADR-2026-09-28-onboarding-v2-etapa-1). Misma secuencia que la primera generación de
// siempre —producto → variante → subida full + thumbnail → fila de imagen →
// categorización—, porque es la que el backend espera para generar con `product_id`.
// Queda en el catálogo: la próxima vez ya está para elegir.

import { supabase } from '../supabase';
import { categorizeProduct } from '../categorizeProduct';
import { buildThumbnailBlob } from '../../utils/thumbnail';
import { enGuion } from './guion';

export interface ProductoCreado {
  productId: string;
  varianteId: string;
}

export async function crearProductoDesdeFoto(p: {
  file: File;
  nombre: string;
  companyId: string;
  brandId: string | null;
}): Promise<ProductoCreado> {
  if (enGuion()) return { productId: 'guion-producto', varianteId: 'guion-variante' };
  const nombre = p.nombre.trim() || 'Producto 1';
  const {
    data: { user },
  } = await supabase.auth.getUser();

  const { data: producto, error: errProducto } = await supabase
    .from('productos')
    .insert({
      id_company: p.companyId,
      nombre,
      tiene_variantes: false,
      ...(p.brandId ? { brand_id: p.brandId } : {}),
    })
    .select('id')
    .single();
  if (errProducto) throw errProducto;
  const productId = String((producto as { id: string | number }).id);

  const { data: variante, error: errVariante } = await supabase
    .from('variantes')
    .insert({ id_company: p.companyId, nombre, activo: true, product_id: productId })
    .select('id')
    .single();
  if (errVariante) throw errVariante;
  const varianteId = String((variante as { id: string }).id);

  const archivo = `${Date.now()}_${p.file.name.replace(/[^a-zA-Z0-9._-]/g, '_')}`;
  const { error: errSubida } = await supabase.storage
    .from('productos')
    .upload(`${p.companyId}/${varianteId}/full/${archivo}`, p.file);
  if (errSubida) throw errSubida;
  try {
    const blob = await buildThumbnailBlob(p.file);
    if (blob) await supabase.storage.from('productos').upload(`${p.companyId}/${varianteId}/opt/${archivo}`, blob);
  } catch {
    /* sin thumbnail la app cae a la imagen full */
  }

  const { error: errImagen } = await supabase.from('productos_imagenes').insert({
    id_company: p.companyId,
    variante_id: varianteId,
    url: archivo,
    principal: true,
    orden: 1,
  });
  if (errImagen) throw errImagen;

  // Fire & forget, sin `modo`: el mismo contrato que la primera generación.
  categorizeProduct(productId, user ? { userId: user.id } : undefined);
  return { productId, varianteId };
}
